const controllingPersonTypes = [
  { key: 1, value: 'Legal person: ownership' },
  { key: 2, value: 'Legal person: other means' },
  { key: 3, value: 'Legal person: snr. managing official' },
  { key: 4, value: 'Trust: settlor' },
  { key: 5, value: 'Trust: trustee' },
  { key: 6, value: 'Trust: protector' },
  { key: 7, value: 'Trust: beneficiary' },
  { key: 8, value: 'Trust: other' },
  { key: 9, value: 'Other: settlor-equivalent' },
  { key: 10, value: 'Other: trustee-equivalent' },
  { key: 11, value: 'Other: protector-equivalent' },
  { key: 12, value: 'Other: beneficiary-equivalent' },
  { key: 13, value: 'Other: other-equivalent' }
];

controllingPersonTypes.findByKey = (key) => {
  if (!key || key <= 0) {
    return null;
  }

  const code = controllingPersonTypes.find(x => x.key === key);
  return code && code.value ? code.value : null;
};

export default controllingPersonTypes;
